// Mirrors MAX_TRIAL_EXTENSION_DAYS / MAX_TRIAL_DAYS_REMAINING in api/views/billing_view.py,
// which enforces them.
export const MAX_TRIAL_EXTENSION_DAYS = 7;
export const MAX_TRIAL_DAYS_REMAINING = 10;

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Shopify's AppSubscription only returns the total `trialDays` and the
 * subscription's `createdAt`; the trial starts at creation, so the remaining
 * days are counted back from there. Partial days round up (a trial ending
 * later today still has 1 day left). Returns null when there is no trial or
 * the creation date is missing/invalid.
 */
export const getTrialDaysRemaining = (
  trialDays: number | null | undefined,
  createdAt: string | null | undefined,
  now: Date = new Date(),
): number | null => {
  if (!trialDays || trialDays <= 0 || !createdAt) return null;
  const start = Date.parse(createdAt);
  if (Number.isNaN(start)) return null;
  const trialEnd = start + trialDays * DAY_MS;
  return Math.max(0, Math.ceil((trialEnd - now.getTime()) / DAY_MS));
};

/** How many days the trial may still be extended by in one go (0 when it can't be). */
export const getMaxTrialExtension = (daysRemaining: number | null): number => {
  if (!daysRemaining) return 0;
  return Math.max(0, Math.min(MAX_TRIAL_EXTENSION_DAYS, MAX_TRIAL_DAYS_REMAINING - daysRemaining));
};
